
// src/api.js

let API_BASE;

if (process.env.NODE_ENV === "production") {
  // W produkcji backend jest pod tym samym hostem: /api/...
  API_BASE = "";
} else {
  // Lokalnie backend działa na localhost:5001
  API_BASE = "http://localhost:5001";
}

export default API_BASE;
